import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';

const endpoint = 'api/v1/cms/supplier-profiles/by-supplier';

interface CommissionData {
  commissionRate: number | null;
}

type TData = CommissionData;
type TError = AxiosError;
type TQueryKey = [typeof endpoint, number | undefined];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

// Send Order modal prefill. Errors are silent by design (spec): a failed lookup just means
// no default — the operator can still type a commission.
export function useGetSupplierProfileCommissionApi(supplierId: number | undefined, options?: Options): ReturnType {
  const isLoggedIn = useIsLoggedIn();

  const queryFn = async () => {
    const { data } = await http.get(`${endpoint}/${supplierId}`);
    return data?.data ?? { commissionRate: null };
  };

  return useQueryWrapper([endpoint, supplierId], queryFn, {
    enabled: isLoggedIn && !!supplierId,
    ...options,
  });
}
